/* eslint-disable prefer-destructuring */
import groups from '../../core/groups';

export const operations = groups.operations;
export const selectors = groups.selectors;
export default groups;
